module.exports = __webpack_public_path__ + "static/media/IMG20240514101553.9c65add7.jpg";